import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CreaticsRoutingModule } from './creatics-routing.module';
import { RouterOutletComponent } from './components/router-outlet/router-outlet.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { OnboardingModule } from 'src/app/features/onboarding/onboarding.module';
import { HomepageComponent } from './components/homepage/homepage.component';
import { CreaticsAboutComponent } from './components/creatics-about/creatics-about.component';
import { LoggedInHomepageComponent } from './components/logged-in-homepage/logged-in-homepage.component';
import { CarouselModule  } from 'ngx-owl-carousel-o';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import {ImageCropperModule} from 'ngx-image-cropper'
import { TeamComponent } from './team/team.component';
import { FeaturedGuestsComponent } from './featured-guests/featured-guests.component';
import { BadgesAwardsComponent } from './badges-awards/badges-awards.component';
import { PaymentReceiptComponent } from './payment-receipt/payment-receipt.component';
import { CreateYourDreamsComponent } from './create-your-dreams/create-your-dreams.component';
import { MeetTheCreaticsComponent } from './meet-the-creatics/meet-the-creatics.component';
import { PricingAndAccessComponent } from './pricing-and-access/pricing-and-access.component';
import { PricingAccessPaymentReceiptComponent } from './pricing-and-access/pricing-access-payment-receipt/pricing-access-payment-receipt.component';
import { TermsComponent } from 'src/app/shared/creatics/common/terms&conditions/terms.component';
import { PrivacyComponent } from 'src/app/shared/creatics/common/privacy-policy/privacy.component';
import { PrizesAndPerksComponent } from './prizes-and-perks/prizes-and-perks.component';
import { CustomFxModule } from 'src/app/core/custom-fx/custom-fx.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MixpanelModule } from 'src/app/shared/mix-pane.modul';
@NgModule({
  declarations: [
    RouterOutletComponent,
    HomepageComponent,
    CreaticsAboutComponent,
    LoggedInHomepageComponent,
    TeamComponent,
    FeaturedGuestsComponent,
    BadgesAwardsComponent,
    PaymentReceiptComponent,
    CreateYourDreamsComponent,
    MeetTheCreaticsComponent,
    PricingAndAccessComponent,
    PricingAccessPaymentReceiptComponent,
    TermsComponent,
    PrivacyComponent,
    PrizesAndPerksComponent
  ],
  imports: [
    CommonModule,
    OnboardingModule,
    CreaticsRoutingModule,
    SharedModule,
    FlexLayoutModule,
    ImageCropperModule,
    CarouselModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    HttpClientModule,
    FormsModule,
    CustomFxModule,
    MatDialogModule,
    MixpanelModule

  ]
})
export class CreaticsModule { }
